// src/theme/tokens/sizes.js
// Source of truth for Figma icon + avatar sizing tokens

export const sizes = {
  icon: {
    xs: 12,
    s: 16,
    m: 20,
    l: 24,
    xl: 32,
  },
  avatar: {
    s: 24,
    m: 40,
    l: 64,
  },
  // Control heights (Button/Input/Select ladder)
  controlHeight: {
    sm: 22,
    md: 38,
    lg: 46,
  },
  drawer: {
    minimized: 120,
    default: "60%", // Viewport-aware: scales with screen height, prevents overflow in mobile landscape
    large: "90%",
  },
};

